type Page = {
    key: string;
    url: string;
    value: string;
}

export const PAGE_ADMIN_MENU_OVERVIEW: Page = {
    key: 'admin-navigation-menu-overview',
    url: '/navigation/admin-overview',
    value: 'Menu Configuration',
}

export const PAGE_ADMIN_MENU_SETTINGS: Page = {
    key: 'admin-navigation-menu-settings',
    url: '/navigation/admin-menu-settings',
    value: 'Menu Settings',
}

export const PAGE_ADMIN_SINGLE_MENU_CONFIG: Page = {
    key: 'admin-navigation-configure-menu',
    url: '/navigation/admin-configure-menu',
    value: 'Configure Menu',
}

export const PAGE_GENERAL_MENU_OVERVIEW: Page = {
    key: 'navigation-menu-overview',
    url: '/navigation/admin-overview',
    value: 'Navigation Menu',
}

export const PAGE_GENERAL_SINGLE_MENU_CONFIG: Page = {
    key: 'navigation-configure-menu',
    url: '/navigation/configure-menu',
    value: 'Configure Menu',
}

export const ADMIN_MODULES: Page[] = [
    PAGE_ADMIN_MENU_OVERVIEW,
    PAGE_ADMIN_MENU_SETTINGS,
    PAGE_ADMIN_SINGLE_MENU_CONFIG
];

export const PARAM_APP_MENU_CONFIG_MENU_KEY = 'menuKey';
export const PARAM_APP_MENUITEM_CQL = 'menuItemCqlValue';
export const PARAM_APP_MENUITEM_NAME = 'menuItemName';
export const PARAM_APP_MENUITEM_NEWTAB = 'menuItemOpenInNewTab';
export const PARAM_APP_MENUITEM_IMAGEURL = 'menuItemImageUrl';
